<template>
  <div @click="expand" :class="bgColor" class="py-4 px-3 md:px-6 border-t cursor-pointer">
    <div class="flex flex-wrap md:flex-no-wrap items-start">
      <div class="md:w-32 xl:w-48 flex-none">
        <ul class="flex flex-wrap md:block">
          <li v-for="tax in sammlung" :key="tax.id" :class="`text-${tax.slug}`" class="lowercase mr-2 md:mr-0">
            {{ tax.name }}
          </li>
        </ul>
      </div>
      <div class="flex-auto pr-6">
        <router-link @click.native.stop :to="postLink">
          <h3 class="font-bold text-xl" v-html="post.title_highlighted"></h3>
        </router-link>
        <div v-if="author" v-html="author"></div>
        <div v-html="post.post_excerpt" class="font-thin my-2"></div>
        <div>
          <router-link @click.native.stop :to="postLink" tabindex="-1">
            <span :class="txtColor">&rarr;</span> Weiterlesen
          </router-link>
        </div>
      </div>
      <div class="hidden md:block w-24 lg:w-32 flex-none font-thin text-right pr-4">{{ date }}</div>
    </div>
  </div>
</template>

<script>
  import { format } from 'date-fns/esm'
  import { de } from 'date-fns/esm/locale'
  import { relativeUrl } from '@/utils'

  export default {
    name: 'SearchRow',
    props: {
      post: Object
    },
    computed: {
      expanded: {
        get () {
          return this.$store.state.expanded === this.post.id
        },
        set (newVal) {
          this.$store.commit('EXPAND', newVal)
        }
      },
      sammlung () {
        if (!this.post) return []
        return this.post.categories
      },
      txtColor () {
        const c = this.sammlung[0]
        if (!c) return
        return `text-${c.slug}`
      },
      bgColor () {
        const c = this.sammlung[0]
        if (!c) return
        return `hover:bg-${c.slug}`
      },
      author () {
        if (this.post && this.post.author.includes('<mark')) {
          return this.post.author
        } else {
          return null
        }
      },
      date () {
        if (!this.post) return
        const ds = this.post.post_date.replace(' ', 'T') // Safari fix
        const d = new Date(ds)
        return format(d, 'MMM yyyy', { locale: de })
      },
      postLink () {
        return relativeUrl(this.post?.link)
      }
    },
    methods: {
      expand () {
        this.$router.push(this.postLink)
      }
    }
  }
</script>
